<template>

  <div>
    <div style="width: 100%;">
      <img src="./newsBanner.png" alt="企业动态" style="width: 100%; height: auto;">
    </div>

    <!--关于我们介绍-->
    <div class="wd100 pdtop" style="width: 1255px;margin: 0px auto;position: relative;z-index: 199;height: 2000px">
      <div class="header">
        <span @click="toggleTab(0)" :class="{ active: currentTab === 0 }">公司动态</span>
        <span @click="toggleTab(1)" :class="{ active: currentTab === 1 }">行业新闻</span>
        <span @click="toggleTab(2)" :class="{ active: currentTab === 2 }">媒体报道</span>
      </div>

      <div v-show="currentTab === 0">
        <div class="container" style="" v-for="item in records">
            <div class="image-container" >
              <img :src="item.img" alt="Image Description">
            </div>
            <div class="text-container" >
              <div style="height: 36px">
                <h1 style="width: 600px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                  {{item.title}}</h1>
              </div>
              <div style="height: 36px">
                <p>{{item.publishTime}}</p>
              </div>

              <div style="height: 130px; display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 4;overflow: hidden; ">
                <p>
                  &nbsp;&nbsp; &nbsp;&nbsp;{{item.messageOne}}
                </p>
              </div>

              <div style="height: 130px; display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 4;overflow: hidden;padding-top: 5px ">
                <p>
                  &nbsp;&nbsp; &nbsp;&nbsp;{{item.messageTwo}}
                </p>
              </div>

              <div style="height: 36px;margin-top: 10px">
                <a :href="item.linkUrl" target="_blank">
                  <button>立即查看</button>
                </a>
              </div>
            </div>
        </div>
      </div>

      <div v-show="currentTab === 1">
        <div class="container" style="" v-for="item in records">
          <div class="image-container" >
            <img :src="item.img" alt="Image Description">
          </div>
          <div class="text-container" >
            <div style="height: 36px">
              <h1 style="width: 600px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                {{item.title}}</h1>
            </div>
            <div style="height: 36px">
              <p>{{item.publishTime}}</p>
            </div>

            <div style="height: 130px; display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 4;overflow: hidden; ">
              <p>
                &nbsp;&nbsp; &nbsp;&nbsp;{{item.messageOne}}
              </p>
            </div>

            <div style="height: 130px; display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 4;overflow: hidden;padding-top: 5px ">
              <p>
                &nbsp;&nbsp; &nbsp;&nbsp;{{item.messageTwo}}
              </p>
            </div>

            <div style="height: 36px;margin-top: 10px">
              <a :href="item.linkUrl" target="_blank">
                <button>立即查看</button>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div v-show="currentTab === 2">
        <div class="container" style="" v-for="item in records">
          <div class="image-container" >
            <img :src="item.img" alt="Image Description">
          </div>
          <div class="text-container" >
            <div style="height: 36px">
              <h1 style="width: 600px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                {{item.title}}</h1>
            </div>
            <div style="height: 36px">
              <p>{{item.publishTime}}</p>
            </div>

            <div style="height: 130px; display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 4;overflow: hidden; ">
              <p>
                &nbsp;&nbsp; &nbsp;&nbsp;{{item.messageOne}}
              </p>
            </div>

            <div style="height: 130px; display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 4;overflow: hidden;padding-top: 5px ">
              <p>
                &nbsp;&nbsp; &nbsp;&nbsp;{{item.messageTwo}}
              </p>
            </div>

            <div style="height: 36px;margin-top: 10px">
              <a :href="item.linkUrl" target="_blank">
                <button>立即查看</button>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="container1">
        <el-pagination
          @current-change="handleCurrentChange"
          background
          layout="prev, pager, next"
          :page-size="pageSize"
          :total="total">
        </el-pagination>
      </div>


    </div>
    <div class="wd100 pdtop" style="width: 1255px;margin: 0px auto;height:500px">
    </div>
  </div>


</template>
<style scoped>
@import 'news.css';
</style>
<script>
import {save} from '@/api/common'
import axios from 'axios';

// 创建API客户端（针对8089端口）
const apiClient = axios.create({
  baseURL: process.env.NODE_ENV === 'production'
    ? '/jeecg-boot'
    : 'http://127.0.0.1:8089/jeecg-boot',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
});

// 添加请求拦截器
apiClient.interceptors.request.use(config => {
  // 开发环境添加特殊头，帮助调试CORS
  if (process.env.NODE_ENV === 'development') {
    config.headers['X-Debug-Origin'] = window.location.origin;
  }
  return config;
});

export default {
  components: {},
  data() {
    return {
      pageSize: 5,
      total: 1,
      currentTab: 0, // 当前选中的 tab，0=公司动态，1=行业新闻，2=媒体报道
      formData: {
        pageNo: 1,
        pageSize: 5,
        type: 2, // type，0=公司动态，1=行业新闻，2=媒体报道
      },
      records:[]
    }
  },

  methods: {
    handleCurrentChange(page){
      this.formData.pageNo = page
      this.getList();
      // 滚动到指定位置
      window.scrollTo(0, 500);
    },
    toggleTab(index) {
      this.currentTab = index;
      this.formData.pageNo = 1
      if(index == 0){
        this.formData.type = 2//公司动态

      }else if(index == 1){
        this.formData.type = 1//行业新闻

      }else if(index == 2){
        this.formData.type = 3//媒体报道
      }
      this.getList();
    },
    async getList(){
      const res =  await  apiClient.get('/newsCenter/newsCenter/list', {
        params: this.formData, // 使用 params 来传递查询参数
        // 显式设置凭证模式为 false
        withCredentials: false,

        // 添加额外的CORS相关头
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Sec-Fetch-Mode': 'cors'
        }
      });
      if (res.data.success) {
        this.total = res.data.result.total
        this.pageSize = res.data.result.size
        this.records = res.data.result.records
      }
    }
  },
  mounted: function () {
    // 获取所有按钮
    const buttons = document.querySelectorAll('.header span');

    // 遍历每个按钮并添加点击事件
    buttons.forEach(button => {
      button.addEventListener('click', () => {
        // 移除所有按钮的 active 类
        buttons.forEach(btn => btn.classList.remove('active'));
        // 给当前点击的按钮添加 active 类
        button.classList.add('active');
      });
    });

    this.getList();
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/news/news.vue